import { apiGet, apiPost, apiPut, apiDelete } from '../lib/api'

export const LOCATIONS_LOAD_SUCCESS = 'LOCATIONS_LOAD_SUCCESS'
export const LOCATIONS_LOAD_ACTIVE_SUCCESS = 'LOCATIONS_LOAD_ACTIVE_SUCCESS'
export const LOCATIONS_LOAD_START = 'LOCATIONS_LOAD_START'
export const LOCATIONS_LOAD_ERROR = 'LOCATIONS_LOAD_ERROR'
export const LOCATION_CREATE_SUCCESS = 'LOCATION_ADD_SUCCESS'
export const LOCATION_LOAD_SUCCESS = 'LOCATION_LOAD_SUCCESS'
export const LOCATION_UPDATE_SUCESS = 'LOCATION_UPDATE_SUCESS'
export const LOCATION_DELETE_SUCCESS = 'LOCATION_DELETE_SUCCESS'
export const LOCATION_SET_LAST_SELECTED = 'LOCATION_SET_LAST_SELECTED'

export const CLEAR_LOCATIONS = 'CLEAR_LOCATIONS'
export const CLEAR_LOCATION = 'CLEAR_LOCATION'

export const loadLocations = (query) => ({ getState, fetch }) => ({
  type: 'LOCATIONS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'locations',
    getState,
    query,
  }),
})

export const loadActiveLocations = (query) => ({ getState, fetch }) => ({
  type: 'LOCATIONS_LOAD_ACTIVE',
  payload: apiGet({
    fetch,
    endpoint: 'locationsactive',
    getState,
    query,
  }),
})

export const loadLocation = (id) => ({ getState, fetch }) => ({
  type: 'LOCATION_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `locations/${id}`,
    getState,
  }),
})

export const createLocation = (body) => ({ getState, fetch }) => ({
  type: 'LOCATION_CREATE',
  payload: apiPost({
    fetch,
    endpoint: 'locations',
    getState,
    body,
  }),
})

export const updateLocation = (body) => ({ getState, fetch }) => ({
  type: 'LOCATION_UPDATE',
  payload: apiPut({
    fetch,
    endpoint: `locations/${body._id}`,
    getState,
    body,
  }),
})

export const deleteLocation = (id) => ({ getState, fetch }) => ({
  type: 'LOCATION_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `locations/${id}`,
    getState,
  }),
})

export const setLastSelectedLocation = (id) => ({
  type: 'LOCATION_SET_LAST_SELECTED',
  payload: { id },
})

export const clearLocations = () => ({
  type: 'CLEAR_LOCATIONS',
  payload: {},
})

export const clearLocation = () => ({
  type: 'CLEAR_LOCATION',
  payload: {},
})

export const getLocationsCSV = (query) => ({ getState, fetch }) => ({
  type: 'DOWNLOAD_LOCATIONS_CSV',
  payload: apiGet({
    fetch,
    endpoint: 'locations/csv',
    getState,
    query,
  }),
})



// WEBPACK FOOTER //
// ./src/common/locations/actions.js